// Centralized API base config.
// If REACT_APP_BACKEND_URL is not set, we fall back to same-origin "/api".
// This prevents "undefined/api" bugs and makes deployments more resilient.

const rawBase = process.env.REACT_APP_BACKEND_URL;

export const BACKEND_BASE_URL = rawBase ? rawBase.replace(/\/$/, "") : "";
export const API_BASE_URL = BACKEND_BASE_URL ? `${BACKEND_BASE_URL}/api` : "/api";
